import { Injectable } from '@angular/core';
import { Navigable, NavigationService } from './navigation.service';

@Injectable()
export class NavigationLinkService {
  constructor(private navigation: NavigationService) {}

  goToLocationGlid(glid: string): string {
    return this.navigation.localLoads().locations({ queryParams: { glid }}).getUri();
  }

  goToLocationName(name: string): string {
    return this.navigation.localLoads().locations({ queryParams: { name: name }}).getUri();
  }

  goToCarrierName(carrierName: string, isSelf: boolean): string {
    return isSelf ?
      this.navigation.selfCarrier().editOwn().getUri() :
      this.navigation.carriers().list({ queryParams: { name: carrierName }}).getUri();
  }

  goToCarrierCode(carrierCode: string, isSelf: boolean): string {
    return isSelf ?
      this.navigation.selfCarrier().editOwn().getUri() :
      this.navigation.carriers().list({ queryParams: { code: carrierCode }}).getUri();
  }

  goToSubcontractor(carrierId: string, subcontractorName: string, isSelf: boolean): string {
    return isSelf ?
      this.navigation.selfCarrier().subcontractors().list({ queryParams: { name: subcontractorName }}).getUri() :
      this.navigation.carriers().subcontractors(carrierId).list({ queryParams: { name: subcontractorName }}).getUri();
  }

  goToDrivers(carrierId: string, isSelf: boolean): string {
    return isSelf ?
      this.navigation.selfCarrier().drivers().list().getUri() :
      this.navigation.carriers().drivers(carrierId).list().getUri();
  }

  goToSubcontractorDrivers(carrierId: string, subcontractorId: string, isSelf: boolean): string {
    return isSelf ?
      this.navigation.selfCarrier().subcontractors().drivers(subcontractorId).list().getUri() :
      this.navigation.carriers().subcontractors(carrierId).drivers(subcontractorId).list().getUri();
  }

  goToRegion(regionName: string): string {
    return this.navigation.regions().list({ queryParams: { name: regionName }}).getUri();
  }

  goToLoadManagementForLoad(loadNumber: string): string {
    return this.navigation.loadsManagement().searchLoads({ queryParams: { loadNumbers: loadNumber }}).getUri();
  }

  goToLoadManagementForDelivery(deliveryNumber: string): string {
    return this.navigation.loadsManagement().searchLoads({ queryParams: { deliveryNumbers: deliveryNumber }}).getUri();
  }

  goToFindLoadForLoad(loadNumber: string): string {
    return this.navigation.loadsManagement().searchLoads({ queryParams: { loadNumbers: loadNumber }}).getUri();
  }

  goToFindLoadForDelivery(deliveryNumber: string): string {
    return this.navigation.loadsManagement().searchLoads({ queryParams: { deliveryNumbers: deliveryNumber }}).getUri();
  }

  goToHotspot(hotspotName: string): string {
    return this.navigation.hotspots().list({ queryParams: { label: hotspotName }}).getUri();
  }
}
